import { Component, OnInit, Input } from '@angular/core';
import { ProductUnit } from '@core/services/data.service';

@Component({
  selector: 'vnd-per-unit',
  templateUrl: './vnd-per-unit.component.html',
  styleUrls: ['./vnd-per-unit.component.scss']
})
export class VndPerUnitComponent implements OnInit {

  @Input()
  public type: ProductUnit = ProductUnit.Unknown;

  public get name(): string {
    switch (this.type) {
      case ProductUnit.Meter: return 'm';
      case ProductUnit.Kilogram: return 'kg';
      default: return 'đv';
    }
  }

  constructor() { }

  ngOnInit(): void {
  }

}
